<template>
    <el-dialog title="定制表格订单汇总表" :visible.sync="show" :close-on-click-modal="false" width="80%">

        <el-row style="margin:20px 0">
            <el-select v-model="queryParams.type" placeholder="请选择彩种" size="small" style="margin-right:10px">
                <el-option label="双色球" value="00"></el-option>
                <el-option label="大乐透" value="01"></el-option>
                <el-option label="福彩3D" value="02"></el-option>
                <el-option label="排列三" value="03"></el-option>
            </el-select>
            <el-select v-model="queryParams.excleType" placeholder="请选择申请类型" size="small">
                <el-option label="闲置" value="0"></el-option>
                <el-option label="定制" value="1"></el-option>
            </el-select>
            <el-button type="primary" size="small" @click="getList" style="margin-left:10px">查询</el-button>
        </el-row>
        <el-table :header-cell-style="{background:'#93d2f3',color:'#000000'}" :data="tableData" v-loading="tableLoading">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="userName" label="申请人"></el-table-column>
            <el-table-column prop="createTime" label="申请时间"></el-table-column>
            <el-table-column prop="price" label="本版块工作人员是否跟进确认所有需求--划价"></el-table-column>
            <el-table-column prop="suggestsPrice" label="定制表赏金(缩币)"></el-table-column>
            <el-table-column prop="userName" label="特约做表人"></el-table-column>
            <el-table-column prop="newExcel" label="做表人上传表excel"></el-table-column>
            <el-table-column prop="prop" label="申请人签名确认放款">
                <template slot-scope="scope">
                    {{scope.row.node*1 > 3 ? '是' : '否'}}
                </template>
            </el-table-column>
            <el-table-column prop="acceptance" label="申请人满意度"></el-table-column>
        </el-table>

        <div class="pagin">
            <el-pagination background layout="prev, pager, next" :page-size="queryParams.pageSize" :total="queryParams.total" :current-page.sync="queryParams.pageNum" @current-change="getList">
            </el-pagination>
        </div>

        <div>备注：原则上定制一张表在50-300元之间，凡是涉及VBA都是200元以上</div>
    </el-dialog>
</template>

<script>
export default {
    data () {
        return {
            show: false,

            queryParams: {
                type: '00',
                excleType: '0',
                userId: '',

                pageNum: 1,
                pageSize: 10,
                total: 0,
            },

            tableData: [],
            tableLoading: false,
        }
    },
    methods: {
        init () {
            this.show = true
            this.getList()
        },
        getList () {
            this.tableLoading = true
            this.tableData = []

            let params = this.$utils.getParamByJson(this.queryParams);
            this.$http.get('/stage-api/technicianIdle/list?' + params).then(res => {
                console.log('getList', JSON.parse(JSON.stringify(res)))
                this.tableLoading = false
                res.rows.forEach(item => item.payBtnLoading = false)
                this.tableData = res.rows
                this.queryParams.total = res.total
            }).catch(err => {
                this.tableLoading = false
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.pagin {
    margin: 20px auto;
    width: fit-content;
}
</style>